/**
 * SavedRecipients - Quick send with saved recipients
 */
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Mail, Phone, Building2, Star } from 'lucide-react';

const SavedRecipients = ({ savedRecipients, onSelectRecipient }) => {
  if (!savedRecipients || savedRecipients.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-heading">Quick Send</CardTitle>
        <CardDescription>Select a saved recipient</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex gap-3 overflow-x-auto pb-2">
          {savedRecipients.slice(0, 6).map((recipient) => (
            <button
              key={recipient.id}
              onClick={() => onSelectRecipient(recipient)}
              className="flex flex-col items-center p-3 rounded-xl border border-border hover:border-emerald-500 hover:bg-emerald-500/5 transition-colors min-w-[80px]"
              data-testid={`saved-recipient-${recipient.id}`}
            >
              <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center mb-2">
                {recipient.recipient_type === 'email' && <Mail className="w-4 h-4" />}
                {recipient.recipient_type === 'phone' && <Phone className="w-4 h-4" />}
                {recipient.recipient_type === 'bank' && <Building2 className="w-4 h-4" />}
              </div>
              <span className="text-xs font-medium truncate max-w-[70px]">
                {recipient.display_name}
              </span>
              {recipient.is_favorite && (
                <Star className="w-3 h-3 text-amber-500 mt-1" fill="currentColor" />
              )}
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default SavedRecipients;
